import RecentActivityPanelSkeleton from './RecentActivityPanelSkeleton.component';

export default RecentActivityPanelSkeleton;
